import { StyledModalBackgroundComponent } from "./modal-background-component.scss";

const ModalBackgroundComponent = (props) => {
  const { onClick } = props;
  return (
    <StyledModalBackgroundComponent className="modal-background" onClick={onClick} />
  );
};

export default ModalBackgroundComponent;
